import { Typography, Table, Tag, Col, Popover, Menu, Spin, Modal } from "antd";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
} from "../../global";
import {
  Row,
  Icon,
  View,
  Button,
  LoadingIcon,
  Graph,
  Alert,
} from "../../Components";
import { useEffect, useState, useRef } from "react";
import { useRecoilValue, useRecoilState } from "recoil";
import { useNavigate, useMatch } from "react-router-dom";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useCookies } from "react-cookie";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ReactComponent as optionsIcon } from "../../Assets/SVG/Options.svg";
import { ReactComponent as backIcon } from "../../Assets/SVG/Back.svg";
import { ReactComponent as xIcon } from "../../Assets/SVG/CloseSmallB.svg";
import {
  ToolTypes,
  emailVerifyStatus,
  emailVerify,
  getContacts,
  clearAlert as clearAlertAPI,
  updateReport,
  clearAlerts as clearAlertsAPI,
  deleteAlerts as deleteAlertsAPI,
  addAlert as addAlertAPI,
  updateAlert,
  getAlerts,
  addProject,
  deleteProject,
  getProjects,
  updateProject,
  addProjectImage,
  addReport,
  getReports,
  getReportLogs,
} from "../../API";
import {
  THP_ENABLED_ARRAY,
  THP_CHANNEL_ICONS,
  THP_DEFAULT_Y_AXIS,
  THP_CH_ENUM,
  THP_ENABLED_CHANNELS,
} from "../../Tools/THP";
import HelperService from "../../Helpers/HelperService";
import { ResponsiveLine } from "@nivo/line";
import { Storage, Auth, Amplify } from "aws-amplify";
import ReportColumns from "../../Components/Column/ReportColumns";
import _, { set } from "lodash";
import {
  Title,
  Text,
  Space,
  Paper,
  Divider,
  Group,
  UnstyledButton,
} from "@mantine/core";

function Reports() {
  const navigate = useNavigate();
  const [allSites, setAllSites] = useRecoilState(allSitesAtom);

  return (
    <>
      <Title order={2}>Insight</Title>
      <Text c="dimmed" size="sm">
        Get a detailed background of your sensors.
      </Text>
      <Space h="md" />

      <Paper p="md">
        <Group justify="space-between">
          <Text size="xl">Notifications</Text>

          <UnstyledButton>
            <Text size="md" c={Colors.main} td="underline">
              Mark as All Read
            </Text>
          </UnstyledButton>
        </Group>
        <Divider />
        <Space h="lg" />
      </Paper>
    </>
  );
}

export default Reports;
